import React from "react";
import { FilterState } from "@/components/FilterSidebar/FilterState";
import { FilterName } from "@/components/FilterSidebar/types";
import { useTranslation } from "react-i18next";
import { FilterPillsInner } from "./FilterPillsInner";
import { AddFilterPill } from "./AddFilterPill";

export const FilterPills = ({
  filterState,
  onFilterRemove,
  onAddFilter,
  showTitle = false,
}: {
  filterState?: FilterState;
  showTitle?: boolean;
  onFilterRemove?: (name: FilterName) => void;
  onAddFilter?: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex max-w-lg grow gap-2">
      {showTitle && (
        <div className="font-semibold text-muted-foreground uppercase opacity-50">
          {t("global.filters")}
        </div>
      )}
      <div className="flex flex-wrap content-start gap-2">
        <FilterPillsInner
          filterState={filterState}
          onFilterRemove={onFilterRemove}
        />
        <AddFilterPill
          activeFilterCount={filterState?.activeFilterCount() || 0}
          onClick={onAddFilter}
        />
      </div>
    </div>
  );
};
